import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { I18n } from '@app/i18n/strings-keys';

interface ISideBarItemConfig {
  title: string;
  value: string;
  subValue?: string;
}

interface ISideBarBlock {
  title?: string;
  elements: ISideBarItemConfig[];
  divider?: boolean;
}

@Component({
  selector: 'xux-sidebar-details',
  templateUrl: 'xux-sidebar-details.component.html',
  styleUrls: ['./xux-sidebar-details.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class XuxSidebarDetailsComponent {
  @Input() public sidebarInfo: ISideBarBlock[] = [];

  public I18n = I18n;

  public constructor() {}
}
